import { v4 as uuidv4 } from 'uuid';
/**
 * Correlation ID header name
 */
export const CORRELATION_ID_HEADER = 'X-Correlation-ID';
// Simple in-memory storage for browser context
let currentContext;
/**
 * Generates a new correlation ID
 * @returns A new UUID v4 correlation ID
 */
export function generateCorrelationId() {
    return uuidv4();
}
/**
 * Gets the current browser context
 * @returns The current browser context or undefined if not set
 */
export function getBrowserContext() {
    return currentContext;
}
/**
 * Gets the current correlation ID from the browser context
 * or generates a new one if not available
 * @returns The correlation ID
 */
export function getCorrelationId() {
    if (!currentContext) {
        currentContext = {
            correlationId: generateCorrelationId(),
        };
    }
    return currentContext.correlationId;
}
/**
 * Gets the current user ID from the browser context
 * @returns The user ID or undefined if not set
 */
export function getUserId() {
    return currentContext?.userId;
}
/**
 * Sets the correlation ID for the current browser context
 * @param correlationId The correlation ID to set
 */
export function setCorrelationId(correlationId) {
    if (!currentContext) {
        currentContext = { correlationId };
    }
    else {
        currentContext.correlationId = correlationId;
    }
}
/**
 * Sets the user ID for the current browser context
 * @param userId The user ID to set
 */
export function setUserId(userId) {
    if (!currentContext) {
        currentContext = { correlationId: generateCorrelationId(), userId };
    }
    else {
        currentContext.userId = userId;
    }
}
/**
 * Sets a value in the current browser context
 * @param key The key to set
 * @param value The value to set
 */
export function setContextValue(key, value) {
    if (!currentContext) {
        currentContext = { correlationId: generateCorrelationId() };
    }
    currentContext[key] = value;
}
/**
 * Gets a value from the current browser context
 * @param key The key to get
 * @returns The value or undefined if not set
 */
export function getContextValue(key) {
    return currentContext ? currentContext[key] : undefined;
}
/**
 * Clears the current browser context
 */
export function clearBrowserContext() {
    currentContext = undefined;
}
/**
 * Initializes a new browser context with a correlation ID
 * @param correlationId Optional correlation ID, generates one if not provided
 * @returns The initialized context
 */
export function initializeBrowserContext(correlationId) {
    currentContext = {
        correlationId: correlationId || generateCorrelationId(),
    };
    return currentContext;
}
//# sourceMappingURL=browser-correlation-id.js.map